module.exports = __webpack_public_path__ + "media/images/haircut/cover-mobile@2x-0dfdcf28773686797a50eb21b7ec8988.jpg";